import { ConfigurationRepositoryBranchesService } from '@festina/configuration-general-types/configuration/services/ConfigurationRepositoryBranchesService'
import type { ConfigurableServer } from '@festina-life/core'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { allConciseBranchesKeyPrefix } from '../keys/configuration'

type DeleteBranchInputArguments = {
  branchName: string
  server: ConfigurableServer
}

export const useDeleteConciseBranch = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ branchName, server }: DeleteBranchInputArguments) => {
      await ConfigurationRepositoryBranchesService.branchServiceDeleteDeleteBranch(
        {
          branchName,
          componentName: server.toLocaleLowerCase(),
        },
      )
    },
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: [allConciseBranchesKeyPrefix],
      }),
  })
}
